import request from '@/services/request'
import { getApiUrl, getEventApiUrl, getGameApiUrl } from '@/utils/tool'

export function getCategory() {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/category',
    method: 'post'
  })
}

export function getTypeMenuInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/menu-info',
    method: 'post'
  })
}

export function getGames(object) {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: !object.showLoading
    }
  })
}

export function getGamesV2(object) {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/v2',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: !object.showLoading
    }
  })
}

export function getGameList(object) {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/list',
    method: 'post',
    data: object
  })
}

export function getProviderGame() {
  return request({
    baseURL: getGameApiUrl(),
    url: '/game/provider',
    method: 'post'
  })
}

export function getProviderNum() {
  return request({
    baseURL: getEventApiUrl(),
    url: '/game/providerNum',
    method: 'post'
  })
}

export function getGameNum() {
  return request({
    baseURL: getEventApiUrl(),
    url: '/game/num',
    method: 'post'
  })
}

export function getGameProvider(status) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/gameprovider',
    method: 'post',
    data: { status: status }
  })
}

export function gameLaunch(obj) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/launch',
    method: 'post',
    data: obj
  })
}

export function gameBetRecord(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/bet-record-v2',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

export function gameBalance() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/game-balance',
    method: 'post'
  })
}
export function oneGameBalance(obj) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/one-game-balance',
    method: 'post',
    data: obj
  })
}

export function withdrawal(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/withdrawal',
    method: 'post',
    data: object
  })
}
export function deposit(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/deposit',
    method: 'post',
    data: object
  })
}

export function gameLeave(game_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/leave',
    method: 'post',
    data: { game_id: game_id }
  })
}

export function getShowOffGameBets() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/get-show-off-game-bets',
    method: 'post',
    customConfig: {
      mute: true,
      noLoading: true
    }
  })
}
